/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'Ofte stillede spørgsmål (FAQ) – CamAPS FX',
    titleMeta: 'Har du et spørgsmål til CamAPS FX?',
    descriptionMeta: 'Her er svarene på nogle af de oftest stillede spørgsmål om kompatible enheder, myndighedsgodkendelse, tilgængelighed og klinisk forskning',
    keywords:
        'camps faqs, camps fx faqs, ',
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ',
    localeMeta: 'da_dk',

    haveQuestion: 'Har du et spørgsmål til CamAPS FX?',
    hereAnswers: 'Her er svarene på nogle af de oftest stillede spørgsmål.',
    whatIsCamAPS: 'Hvad er CamAPS FX?',
    whatIsCamAPSAnswer: 'CamAPS FX er en avanceret og brugervenlig app til styring af glukoseniveauer hos mennesker fra 1 år og opefter med type 1-diabetes via et avanceret, adaptivt lukket hybridsystem.',
    isApproved: 'Er CamAPS FX godkendt til brug?',
    isApprovedAnswer: 'Appen er blevet grundigt testet i kliniske forsøg og er godkendt til brug i en række lande og regioner, herunder Australien, Canada, Den Europæiske Union, New Zealand, Norge, Schweiz, Storbritannien og USA.',
    isAvailable: 'Er CamAPS FX tilgængelig i mit område?',
    isAvailableAnswer1: 'CamAPS FX er tilgængelig på udvalgte diabetesklinikker eller for personer, som betaler selv og gennemgår onlineoplæring. Spørg på din klinik, eller gå til',
    isAvailableAnswer2: 'Ordrer',
    isAvailableAnswer3: 'for at bestille appen.',
    whatIsLiberty: 'Hvad er CamAPS Liberty?',
    whatIsLibertyAnswer: 'CamAPS Liberty er en funktion i CamAPS FX. Når den er aktiveret, behøver brugerne ikke at tælle kulhydrater eller give bolus før måltider og snacks.',
    whatIsLibertyMoreInfo1: 'Du kan finde flere oplysninger på vores ',
    whatIsLibertyPageLink: 'CamAPS Liberty-side',
    whatIsLibertyMoreInfo2: ' eller downloade dette ',
    whatIsLibertyFactsheetLink: 'faktaark',
    whatIsLibertyMoreInfo3: '.',
    whatIsLibertyFactsheetUrl: '#',
    cost: 'Hvad koster CamAPS FX?',
    costAnswer1: 'Oplysninger om priser kan findes',
    costAnswer2: 'på hjemmesiden.',
    compatibleCgm: 'Hvilke CGM-enheder er kompatible med CamAPS FX?',
    compatibleCgmBody: 'CamAPS FX er kompatibelt med Dexcom G6, Dexcom G7, FreeStyle Libre 3 og FreeStyle Libre 3 Plus. Klik på linkene for at se, hvilke smartphones og operativsystemer der er kompatible.',
    whatPumps: 'Hvilke insulinpumper er kompatible med CamAPS FX?',
    whatPumpsAnswer1: 'CamAPS FX er kompatibel med YpsoPump-insulinpumper på Google Play og i Apple App Store.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: '',
    whatPumpsAnswerHtml: 'https://advancedtherapeutics.org.uk/shop/dana-diabecare-insulin-pump/dana-rs-insulin-pump-2018',
    whatPhone: 'Hvilke smartphones er kompatible med CamAPS FX?',
    whatPhoneAnswer: 'Din smartphone skal være kompatibel med det CGM-system, du bruger.',
    cgmManufacturerListText: 'Tjek venligst CGM-producentens kompatibilitetsliste for Dexcom G6, Dexcom G7, FreeStyle Libre 3 eller FreeStyle Libre 3 Plus.',
    whatOperating: 'Hvilke operativsystemer er kompatible med CamAPS FX?',
    whatOperatingAnswer: 'CamAPS FX understøtter Android 13 til 16 og iOS 18 til 27, herunder efterfølgende mindre opdateringer. Dit operativsystem skal desuden være kompatibelt med det CGM-system, du bruger.',
    whatOperatingManufacturerText: 'Tjek venligst kompatibilitetslisten fra din CGM-producent for Dexcom G6, Dexcom G7, FreeStyle Libre 3 eller FreeStyle Libre 3 Plus.',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerDexcomG7Html:'https://www.dexcom.com/en-GB/compatibility/g7',
    whatPhoneAnswerLibreHtml:'https://freestyleserver.com/Payloads/IFU/2026/q2/ART43193-006_rev-AP-pub.pdf',

    whereUpload: 'Hvor kan jeg uploade mine data fra CamAPS FX?',
    whereUploadAnswer: 'I øjeblikket kan data fra CamAPS FX uploades til mylife Cloud og Glooko.',
    whatLanguage: 'Hvilke sprog er tilgængelige i CamAPS FX?',
    whatLanguageAnswer: 'CamAPS FX er tilgængelig på engelsk, tjekkisk, dansk, hollandsk, fransk, finsk, tysk, italiensk, norsk, polsk, spansk og svensk.',
    whereResults: 'Hvor kan jeg finde resultaterne af de kliniske forsøg?',
    whereResultsAnswer1: 'Publikationer vedrørende brug af Cambridge-kontrolalgoritmen kan downloades',
    whereResultsAnswer2: 'her.',
    whereResultsAnswer3: 'Vigtige publikationer er offentliggjort i',
    whereResultsAnswer4: 'og',

    wantMoreInfoIOS: 'Vil du gerne vide mere om CamAPS FX iOS-appen?',
    wantMoreInfoIOSanswer1: '',
    wantMoreInfoIOSanswer2: 'Klik her',
    wantMoreInfoIOSanswer3: 'for at læse mere.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_DK_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_DK.pdf',
};
